import CryptoJS from 'crypto-js';
import { useAppSelector } from './useAppSelector';
import { getAppAccessToken } from 'Utils/appAccessToken';
import { decodeJwtPayload } from 'Utils/decodeJwtPayload';
import { getCurrentAuthToken } from 'Utils/getCurrentAuthToken';

export const login = () => {
  let state = CryptoJS.lib.WordArray.random(20).toString();
  let nOnce = CryptoJS.lib.WordArray.random(20).toString();
  state = CryptoJS.SHA3(state, { outputLength: 512 }).toString().replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '').substring(0, 21);

  nOnce = CryptoJS.SHA3(nOnce, { outputLength: 512 }).toString().replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '').substring(0, 21);
  const href = new URL(window.location.href);

  //get path name and remove first '/'
  const pathName = href.pathname.substring(href.pathname.indexOf('/') + 1);

  let redirect_uri = encodeURIComponent(import.meta.env.VITE_APP_REDIRECT_URL_FIM + pathName || '');

  const ssoUrl: string =
    `${import.meta.env.VITE_APP_LOGIN}?client_id=${import.meta.env.VITE_APP_CLIENT_ID}` +
    '&redirect_uri=' +
    redirect_uri +
    '&response_type=id_token&scope=openid&state=' +
    state +
    '&response_mode=query&nonce=' +
    nOnce;

  document.location = ssoUrl;
};

export const useAuth = () => {
  const otpData = useAppSelector(({ otpLoginDetails: { otpLoginDetails } }) => otpLoginDetails);

  const token = getCurrentAuthToken(otpData?.token);
  const isDevEnvironment = import.meta.env.DEV;

  if (token) {
    const decodedPayload = decodeJwtPayload(token);
    if (!decodedPayload) {
      return { isAuth: true, isOtp: false };
    }
    const isOtp = decodedPayload.iss === import.meta.env.VITE_APP_OTP_ISS;

    if (!isOtp && !isDevEnvironment && !sessionStorage.getItem('B2CToken') && !getAppAccessToken()) {
      window.sessionStorage.setItem('token', token);
    }

    return { isAuth: true, isOtp };
  }

  return { isAuth: false, isOtp: false };
};

export const useIsOtpLogin = () => {
  const otpData = useAppSelector(({ otpLoginDetails: { otpLoginDetails } }) => otpLoginDetails);
  const token = getCurrentAuthToken(otpData?.token);

  if (token) {
    const decodedPayload = decodeJwtPayload(token);
    if (!decodedPayload) {
      return { isAuth: true, isOtp: false };
    }
    const isOtp = decodedPayload.iss === import.meta.env.VITE_APP_OTP_ISS;

    const expirationDate = new Date(decodedPayload.exp * 1000);
    const currentDate = new Date();
    if (expirationDate >= currentDate) {
      return { isAuth: true, isOtp };
    } else {
      return { isAuth: false, isOtp };
    }
  } else {
    return { isAuth: false, isOtp: false };
  }
};
